import TravelRequirementsNotice from "../components/travel/TravelRequirementsNotice";
import {useLocation, useNavigate} from "react-router-dom";
import {useFlightSearchStore} from "../store/useFlightSearchStore";
import React, {useState} from "react";
import {FiCalendar} from "react-icons/fi";
import {RoundTripFlightMatch} from "../models/RoundTripFlightMatch";
import {FlightSearchData, TripType} from "../models/flightSearchData";
import {SelectorType} from "../models/FlightSearch";
import {useTranslation} from "../i18n/LanguageProvider";
import HomeButton from "../components/buttons/homeButton";
import {FlightSearchBar} from "../components/search/flightSearchBar";
import FlightSearchSelection from "../components/selector/FlightSearchSelection";
import OneWayFlightCalendarView from "../components/calendar/OneWayFlightCalendarView";
import MobileFlightResult from "./MobileFlightResult";
import cardsIcon from "../assets/images/mobile/prototype/cards.svg";
import listIcon from "../assets/images/mobile/prototype/list.svg";

const CalendarIcon = FiCalendar as unknown as React.FC;
interface Props {
    flights: RoundTripFlightMatch[];
    isLoading: boolean;
    searchData: FlightSearchData;
    setSearchData: React.Dispatch<React.SetStateAction<FlightSearchData>>;
    onSearch: () => void;
    subtitle?: string;
}

export default function MobileResults({flights, isLoading, searchData, setSearchData, onSearch, subtitle}: Props) {
    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const setData = useFlightSearchStore((state) => state.setData);
    const [view, setView] = useState<"cards" | "list" | "calendar">("list");
    const [editing, setEditing] = useState(false);
    const [activeSelector, setActiveSelector] = useState<SelectorType | null>(null);
    const isOneWay = searchData.tripType === TripType.OneWay;
    const activeView = view === "calendar" && !isOneWay ? "list" : view;

    return (
        <main className="mobile-prototype mobile-results">
            <div className="mobile-results-inner">
                <header className="mobile-results-header">
                    <div>
                        <h1>{t("mobile.resultsTitle")}</h1>
                        <button type="button" className="mobile-edit-search" aria-expanded={editing}
                            onClick={() => setEditing(value => !value)}>
                            {editing ? t("destination.close") : t("mobile.editSearch")}
                        </button>
                    </div>
                    <div className="mobile-brand"><HomeButton /></div>
                </header>
                {editing && <div className="mobile-results-search">
                    <FlightSearchBar activeSelector={activeSelector} setActiveSelector={setActiveSelector}
                        searchData={searchData} setSearchData={setSearchData}
                        onSearch={() => {setEditing(false); onSearch();}} />
                    {activeSelector && <FlightSearchSelection activeSelector={activeSelector} setActiveSelector={setActiveSelector}
                        flightSearchData={searchData} setFlightSearchData={setSearchData} />}
                    {location.pathname === "/search" && <button type="button" className="mobile-edit-search"
                        onClick={() => {setData(searchData); navigate("/compare");}}>{t("searchBar.compare")}</button>}
                </div>}
                <TravelRequirementsNotice active={!!searchData.travelProfile} empty={!isLoading && flights.length === 0} />
                {subtitle && <p className="mobile-results-subtitle">{subtitle}</p>}
                <div className="mobile-results-content" aria-busy={isLoading}>
                    {isLoading ? <div role="status" className="mobile-results-loading">
                        <span className="animate-spin rounded-full h-10 w-10 border-4 border-accent border-t-transparent" />
                        <span>{t("common.loading")}</span>
                    </div> : flights.length === 0 ? <p className="mobile-results-empty">{t("mobile.emptyResults")}</p>
                    : activeView === "calendar" ? <OneWayFlightCalendarView flightList={flights} dateFrom={searchData.dateFrom} dateTo={searchData.dateTo} />
                    : flights.map((flight, index) => <MobileFlightResult key={`${flight.round_trip_flight.outbound_flight.destination_iata}-${index}`}
                        flightMatch={flight} compact={activeView === "list"} />)}
                </div>
            </div>
            <div className="mobile-view-dock">
                <div className="mobile-view-toggle" role="group" aria-label={t("mobile.resultsView")}>
                    <button type="button" aria-label={t("mobile.cards")} aria-pressed={activeView === "cards"} onClick={() => setView("cards")}>
                        <img src={cardsIcon} alt="" />
                    </button>
                    <button type="button" aria-label={t("resultsView.list")} aria-pressed={activeView === "list"} onClick={() => setView("list")}>
                        <img src={listIcon} alt="" />
                    </button>
                    {isOneWay && <button type="button" aria-label={t("resultsView.calendar")} aria-pressed={activeView === "calendar"} onClick={() => setView("calendar")}>
                        <CalendarIcon />
                    </button>}
                </div>
            </div>
        </main>
    );
}
